import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
// import ProximasCarreras from './views/proximas_carreras/proximas_carreras';
import ProtectedRouters from './routers/ProtectedRouters';
import Login from './views/login/login';
import { LoginProvider } from './context/Login.context';
import Layaout from './views/main/layaout'
import Hipodromo from './views/hipodromo/hipodromo'
import Estadisticas from './views/proximas_carreras/estadisticas';
import WelcomeScreen from "./views/bienvenida/bienvenida";
import Register from "./views/register/register";
import ReCode from "./views/register/re_code";

import ForgotPassword from "./views/forgot_password/forgot_password";
import ResetPassword from "./views/forgot_password/reset_password";
import TermsAndConditionsMobile from './views/terminos/termsandconditions'
import SubscriptionScreen from './views/subcriptions/subcription';
import Userperfil from "./views/perfil/userperfil";
import SelectCarreras from "./views/hipodromo/select_carreras";
import Simulacion from "./views/hipodromo/componenters/simulacion";
import HandicapView from "./views/hipodromo/handicap";
import PredicHandicapView from "./views/hipodromo/componenters/predic_handicap";
import AgentView from "./views/agent/AgentView";
const routers = createBrowserRouter([{
      path: '/login',
      element: <Login />
    },
    {
      path: '/mock',
      element: <WelcomeScreen />
    },
    {
      path: '/register',
      element: <Register />
    },
    {
      path: '/re_code/:email',
      element: <ReCode />
    },
    {
      path: '/forgot',
      element: <ForgotPassword />
    },
    {
      path: '/reset',
      element: <ResetPassword />
    },
  {
    path: '/',
    element:<ProtectedRouters />,
    children:[
      {
        path: '/bienvenida',
        element: <Layaout><WelcomeScreen /></Layaout>
      },
        {
        path: '/terminos',
        element: <Layaout><TermsAndConditionsMobile /></Layaout>
      },
      {
      path: '/hipodromo/:hipodromoId',
      element:  <Layaout><Hipodromo /></Layaout>
      },
        {
      path: '/hipodromo/:hipodromoId/carrera/:id',
        element:  <Layaout><SelectCarreras /></Layaout>
      },{
        path: '/hipodromo/:hipodromoId/carrera/:proCarIdHipodromo/handicap',
      element:  <Layaout><HandicapView /></Layaout>
      },
        {
        path: '/hipodromo/:hipodromoId/carrera/:proCarIdHipodromo/predic-handicap',
      element:  <Layaout><PredicHandicapView /></Layaout>
      },
        {
        path: '/hipodromo/:hipodromoId/carrera/:id/agent',
        element:  <Layaout><AgentView /></Layaout>
      },
        {
      path: '/hipodromo/:hipodromoId/carrera/:id/simulacion',
      element:  <Layaout><Simulacion /></Layaout>
      },

      {
        path: '/proximas_carreras_estadisticas',
        element:  <Layaout><Estadisticas /></Layaout>
      },
      {
          path: '/subscription',
          element: <Layaout><SubscriptionScreen /></Layaout>
      },
       {
          path: '/perfil',
          element: <Layaout><Userperfil /></Layaout>
      }
    ]
}])
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(

  <React.StrictMode>
    <LoginProvider>
      <RouterProvider router={routers} />
    </LoginProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();